import "core-js/modules/es6.object.keys";
import _slicedToArray from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
import _classCallCheck from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
import isPlainObject from 'lodash-es/isPlainObject';
var defaultGroupSeperator = '&';
var defaultPairSeperator = '=';

var KVJoiner = /*#__PURE__*/function () {
  function KVJoiner() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$groupSeperator = _ref.groupSeperator,
        groupSeperator = _ref$groupSeperator === void 0 ? defaultGroupSeperator : _ref$groupSeperator,
        _ref$pairSeperator = _ref.pairSeperator,
        pairSeperator = _ref$pairSeperator === void 0 ? defaultPairSeperator : _ref$pairSeperator,
        _ref$shouldSkipEmpty = _ref.shouldSkipEmpty,
        shouldSkipEmpty = _ref$shouldSkipEmpty === void 0 ? true : _ref$shouldSkipEmpty,
        _ref$shouldEncode = _ref.shouldEncode,
        shouldEncode = _ref$shouldEncode === void 0 ? true : _ref$shouldEncode;

    _classCallCheck(this, KVJoiner);

    this.groupSeperator = groupSeperator;
    this.pairSeperator = pairSeperator;
    this.shouldSkipEmpty = shouldSkipEmpty;
    this.shouldEncode = shouldEncode;
    this.buffer = new Map();
  }

  _createClass(KVJoiner, [{
    key: "join",
    value: function join() {
      var _this = this;

      var content = _toConsumableArray(this.buffer).filter(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            v = _ref3[1];

        return !(_this.shouldSkipEmpty && (v === '' || v === undefined || v === null));
      }).map(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            k = _ref5[0],
            v = _ref5[1];

        return _this.joinPair(k, v);
      }).join(this.groupSeperator);

      this.clear();
      return content;
    }
  }, {
    key: "add",
    value: function add(keys, val) {
      var _this2 = this;

      if (isPlainObject(keys)) {
        Object.keys(keys).forEach(function (key) {
          return _this2.buffer.set(key, keys[key]);
        });
      } else {
        this.buffer.set(keys, val);
      }

      return this;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.buffer.clear();
      return this;
    }
  }, {
    key: "joinPair",
    value: function joinPair(k, v) {
      return "".concat(k).concat(this.pairSeperator).concat(this.shouldEncode ? encodeURIComponent(v) : v);
    }
  }]);

  return KVJoiner;
}();

export { KVJoiner as default };